<template>
    <section class="shipment-progress">
        <div class="h-100">
            <div class="row custom-row">
                <div class="col custom-col">
                    <div class="card-stepper custom-card">
                        <div class="card-body custom-card-body">
                            <div
                                class="steps custom-d-flex custom-flex-row custom-justify-content-between custom-align-items-center"
                            >
                                <div
                                    class="custom-d-flex custom-flex-column custom-align-items-start"
                                >
                                    <small>Shipment <br />Booked</small>
                                </div>
                                <div
                                    class="custom-d-flex custom-flex-column custom-justify-content-center"
                                >
                                    <small>Picked up</small>
                                </div>
                                <div
                                    class="custom-d-flex custom-flex-column custom-justify-content-center custom-align-items-center"
                                >
                                    <small>In-transit</small>
                                </div>
                                <div
                                    class="custom-d-flex custom-flex-column custom-align-items-center"
                                >
                                    <small>Out for <br />delivery</small>
                                </div>
                                <div
                                    class="custom-d-flex custom-flex-column custom-align-items-end"
                                >
                                    <small>{{
                                        isRTO ? "Returned" : "Delivered"
                                    }}</small>
                                </div>
                            </div>
                            <div
                                class="custom-d-flex custom-flex-row custom-justify-content-between custom-align-items-center custom-align-content-center"
                            >
                                <span
                                    class="custom-dot-grey"
                                    :class="{
                                        'custom-dot': isManifested,
                                        'glow-dot': activeDot === 1
                                    }"
                                ></span>
                                <hr
                                    class="track-line-grey"
                                    :class="{ 'track-line': isPickedUp }"
                                />
                                <span
                                    class="custom-dot-grey"
                                    :class="{
                                        'custom-dot': isPickedUp,
                                        'glow-dot': activeDot === 2
                                    }"
                                ></span>
                                <hr
                                    class="track-line-grey"
                                    :class="{ 'track-line': isInTransit }"
                                />
                                <span
                                    class="custom-dot-grey"
                                    :class="{
                                        'custom-dot': isInTransit,
                                        'glow-dot': activeDot === 3
                                    }"
                                ></span>
                                <hr
                                    class="track-line-grey"
                                    :class="{ 'track-line': isOutForDelivery }"
                                />
                                <span
                                    class="custom-dot-grey"
                                    :class="{
                                        'custom-dot': isOutForDelivery,
                                        'glow-dot': activeDot === 4
                                    }"
                                ></span>
                                <hr
                                    class="track-line-grey"
                                    :class="{ 'track-line': isDelivered }"
                                />
                                <span
                                    class="custom-d-flex custom-justify-content-center custom-align-items-center custom-dot-grey"
                                    :class="{
                                        'custom-dot': isDelivered,
                                        'glow-dot': activeDot === 5
                                    }"
                                >
                                </span>
                            </div>
                            <div class="custom-my-4">
                                <a
                                    href="#"
                                    type="button"
                                    @click="$emit('toggleJourney')"
                                >
                                    Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    props: {
        tracking: {
            required: true,
            type: Object
        }
    },
    computed: {
        isManifested() {
            return this.hasStatus([1010, 1020]);
        },
        // using both because shipment jumps from booked to inTransit.
        isPickedUp() {
            return this.hasStatus([1200, 1220]);
        },
        isInTransit() {
            return this.hasStatus([1220]);
        },
        isOutForDelivery() {
            return this.hasStatus([1700]);
        },
        // either Delivered or RTO returned
        isDelivered() {
            return this.hasStatus([1900, 2030]);
        },
        isRTO() {
            return this.hasStatus([2000]);
        },
        activeDot() {
            let activeDotValue = 0;

            if (this.isDelivered) activeDotValue = 5;
            else if (this.isOutForDelivery) activeDotValue = 4;
            else if (this.isInTransit) activeDotValue = 3;
            else if (this.isPickedUp) activeDotValue = 2;
            else if (this.isManifested) activeDotValue = 1;

            return activeDotValue;
        }
    },
    methods: {
        hasStatus(status) {
            const statusArray = Array.isArray(status) ? status : [status];
            return statusArray.some(code =>
                this.tracking.trackings.some(
                    event => event.status_code === code
                )
            );
        }
    }
};
</script>

<style scoped>
.shipment-progress {
    font-size: 1.6rem;
    font-weight: 700;
    color: #868e96;
    letter-spacing: 1.4px;
    line-height: 1.2;
    margin: 1rem;
}

.steps {
    text-transform: uppercase;
}
.custom-d-flex {
    display: flex;
}

.custom-justify-content-between {
    justify-content: space-between;
}

.custom-align-items-center {
    align-items: center;
}

.custom-flex-column {
    flex-direction: column;
}

.custom-fw-normal {
    font-weight: normal;
}

.custom-my-4 {
    font-size: 1.6rem;
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
    text-align: right;
    font-weight: 600;
}

.custom-dot {
    width: 10px;
    height: 10px;
    background-color: #000;
    border-radius: 50%;
}
.custom-dot-grey {
    width: 10px;
    height: 10px;
    background-color: #ccc;
    border-radius: 50%;
}

.track-line-grey {
    height: 1px;
    background-color: #ccc;
    flex-grow: 1;
}

.custom-card {
    border-radius: 10px;
}

.custom-text-muted {
    color: #6c757d;
}

.custom-dot {
    background-color: #007bff;
}

.track-line {
    background-color: #007bff;
}

.glow-dot {
    width: 15px;
    height: 15px;
    background-color: #007bff;
    border-radius: 50%;
    position: relative;
    animation: pulse 1.5s infinite;
}

@keyframes pulse {
    0% {
        box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.2);
    }
    100% {
        box-shadow: 0 0 0 20px rgba(0, 0, 0, 0);
    }
}

@media screen and (max-width: 768px) {
    .shipment-progress {
        font-size: 1rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ShipmentTimeline.vue